export const tourInfo = {
  label: "Tour Information",
  columns: [
    [
      {
        type: "text",
        name: "students",
        label: "Number of Students",
        description:
          "The maximum group size is 30. Groups must be divided into 2 subgroups of no more than 15, including the chaperone, prior to arrival.",
        required: true,
      },
      {
        type: "text",
        name: "teachers",
        label: "Number of Teachers",
        required: true,
      },
      {
        type: "text",
        name: "adults",
        label: "Number of Chaperones (1-10 ratio is required)",
        required: true,
      },
      {
        type: "text",
        name: "grade",
        label: "Grade Level(s)",
        required: true,
      },
      {
        type: "date",
        name: "preferred_date",
        label: "Preferred Tour Date",
        description:
          "Tours are available Mondays, Tuesdays, Thursdays, Fridays | 10am - 2pm (The Norton is taking tour requests through December 2023)",
        placeholder: "MM/DD/YYYY",
        required: true,
      },
      {
        type: "date",
        name: "alternative_date",
        label: "Alternative Tour Date",
        placeholder: "MM/DD/YYYY",
        required: true,
      },
    ],
    [
      {
        type: "text",
        name: "tour_length",
        label: "Length of Tour",
        required: true,
      },
      {
        type: "radio",
        name: "tour_time",
        label: "Tour times",
        options: [
          { label: "10:00 AM", value: "10:00 AM" },
          { label: "11:00 AM", value: "11:00 AM" },
          { label: "12:00 PM", value: "12:00 PM" },
          { label: "1:00 PM", value: "1:00 PM" },
          { label: "Other", value: "Other" },
        ],
        required: true,
        other: { name: "tour_time_other", label: "Other Tour Time" },
      },
      {
        type: "text",
        name: "goals",
        label: "Goals of Your Visit",
        required: true,
      },
    ],
  ],
};

export const additionalInfo = {
  label: "Additional Information",
  columns: [
    [
      {
        type: "checkbox",
        name: "school_type[]",
        label: "School Type",
        description: "Please select ALL that apply.",
        options: [
          { label: "Public", value: "Public" },
          { label: "Private", value: "Private" },
          { label: "Charter", value: "Charter" },
          { label: "Magnet", value: "Magnet" },
          { label: "Title I", value: "Title I" },
          {
            label:
              "Homeschool (<a href='https://www.norton.org/event-series/homeschool-tours' target=_blank>Learn More</a>)",
            value: "Homeschool",
          },
          { label: "Other", value: "Other" },
        ],
        required: true,
        other: { name: "school_type_other", label: "Other School Type" },
      },
      {
        type: "checkbox",
        name: "classroom_type[]",
        label: "Classroom Type",
        description: "Please select ALL that apply.",
        options: [
          { label: "General Education", value: "General Education" },
          { label: "ELL/ESOL", value: "ELL/ESOL" },
          {
            label: "Special Education/ESE/Gifted",
            value: "Special Education/ESE/Gifted",
          },
          { label: "ASD (autism spectrum disorder)", value: "ASD" },
          { label: "Other", value: "Other" },
        ],
        required: true,
        other: { name: "classroom_type_other", label: "Other Classroom Type" },
      },
      {
        type: "checkbox",
        name: "special_needs[]",
        label:
          "Special accommodations or requests for students with disabilities",
        options: [
          { label: "ASL Interpretation", value: "ASL Interpretation" },
          {
            label: "Handling Objects",
            value: "Handling Objects",
          },
          { label: "AP", value: "AP" },
          {
            label: "ASD (autism spectrum disorder)",
            value: "ASD Special Needs",
          },
          {
            label: "No special accommodations or requests for my group ",
            value: "None",
          },
          { label: "Other", value: "Other" },
        ],
        required: true,
        other: {
          name: "special_needs_other",
          label: "Please specify what accommodations are needed for your group",
          showLabel: true,
          required: true,
        },
      },
    ],
    [
      {
        type: "radio",
        name: "transportation",
        label: "Transportation",
        description:
          "Free busing for Palm Beach County School District schools only.",
        options: [
          {
            label:
              "Yes, I will request transportation via the PBCSD field trip form to apply for free busing.",
            value: "1",
          },
          {
            label: "No, I will arrange my own transportation.",
            value: "0",
          },
        ],
        required: true,
      },
      {
        type: "radio",
        name: "lunch",
        label: "Lunch Space",
        description:
          "Reserve lunch space in the Sculpture Garden for a picnic style lunch. 30-minute lunch.",
        options: [
          { label: "Yes, reserve lunch space", value: "1" },
          { label: "No, thanks", value: "0" },
        ],
        required: true,
      },
      {
        type: "radio",
        name: "lunch_details",
        label: "Please let us know your lunch arrangements for your trip",
        options: [
          {
            label: "Students will bring school lunch, or packed lunches.",
            value: "Students will bring school lunch, or packed lunches",
          },
          {
            label:
              "Some or all of my students are interested in lunch from The Restaurant. I would like information about lunch from The Restaurant.",
            value: "We are interested in lunch from The Restaurant, send info",
          },
          {
            label: "I will not be having lunch at the Museum.",
            value: "I will not be having lunch at the Museum",
          },
        ],
        required: true,
      },
      {
        type: "text",
        name: "lunch_time",
        label: "What time do you have lunch at school?",
        required: true,
      },
      {
        type: "radio",
        name: "educational_materials",
        label: "Educational Materials",
        description:
          "Educational materials to support teacher-led tours can be provided by Norton staff with advanced notice.",
        options: [
          { label: "Yes, I'm interested", value: "1" },
          { label: "No, thanks", value: "0" },
        ],
        required: true,
      },
    ],
  ],
};
